export default __webpack_public_path__ + "static/media/april.cf861d71.md";